import { useContext } from 'react';

import {
  type SharedProgressBarProps,
  SharedProgressBarPropsContext,
} from '../contexts/SharedProgressBarPropsContext.js';

/**
 * @internal
 */
export function useSharedProgressBarPropsContext(): SharedProgressBarProps {
  const context = useContext(SharedProgressBarPropsContext);

  return {
    id: context.id,
    density: context.density,
  };
}
